import { MobileLockTranslationKeysMap, MobileLockType } from './mobile-lock.types';

export const MOBILE_LOCK_TRANSLATION_KEYS: MobileLockTranslationKeysMap = {
  [MobileLockType.LOGGED_IN]: {
    TITLE: 'login.downloadNativeAppPromptTitle',
    SUBTITLE: 'login.downloadNativeAppPromptLoggedInText',
    CTA: 'login.openAppCta',
  },
  [MobileLockType.LOGGED_OUT]: {
    TITLE: 'login.downloadNativeAppPromptTitle',
    SUBTITLE: 'login.downloadNativeAppPromptText',
    CTA: 'login.openAppCta',
  },
};



// WEBPACK FOOTER //
// ./ts/app/shared/mobile-lock/mobile-lock-translations.ts